import React from "react";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCheckCircle, faTimesCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";

import "./PasswordConstraint.scss";

interface Props {
  label: string;
  isValid: boolean;
}

const PasswordConstraint: React.FC<Props> = ({ isValid, label }) => {
  const buildClassNames = () => classNames(`password-constraint--${isValid ? "valid" : "invalid"}`);
  const getIcon = (): IconProp => {
    if (isValid) {
      return faCheckCircle;
    }
    return faTimesCircle;
  };

  return (
    <div className="password-constraint">
      <div className={buildClassNames()}>
        <FontAwesomeIcon icon={getIcon()} />
      </div>
      <div className="password-constraint-info">{label}</div>
    </div>
  );
};

export { PasswordConstraint };
